const messages = {
  loading: "Retrieving Projects...",
  emptyProjects: "No projects found",
  loadingApps: "Loading apps count",
  newProject: "New Project",
  projects: "Projects",
  creatingProject: "Creating new project",
  creatingCA: "Creating Container App",
};
export default messages;